export default "/images/list.svg?8486a1e6df1d1bbfdaae8ad928179eb6";